import ValidationMessages from "../../utils/ValidationMessages";

const InputText = ({ label, state, inputName, handleChange, validator }) => {
    return (
        <div className="mb-4">
            <h5 className="required">
                {label}
            </h5>
            <div className="">
                <textarea
                    name={inputName}
                    rows={5}
                    maxLength={5000}
                    className="form-control"
                    value={state}
                    onChange={(event) => handleChange(event)}
                />
            </div>
            {validator.current.message(inputName, state, "required", ValidationMessages().simple)}
        </div>
    )
}

export default InputText;